module.exports = __webpack_public_path__ + "img/ae836b6.png";